import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {IHourTable, ITimetable} from '../../models/timetable';
import {differenceInMinutes} from 'date-fns';

@Component({
  selector: 'app-set-hours',
  templateUrl: './set-hours.component.html',
  styleUrls: ['./set-hours.component.scss'],
  animations: [fadeInAnimation]
})
export class SetHoursComponent implements OnInit, OnChanges {
  @Input() day: number;
  @Input() disabled = false;
  @Input() timetable: ITimetable;
  @Output() addTimetable: EventEmitter<any> = new EventEmitter();
  @Output() changeTimetableField: EventEmitter<any> = new EventEmitter();
  @Output() removeHourToGroup: EventEmitter<any> = new EventEmitter();
  active: boolean;
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.timetable?.currentValue) {
      if (this.timetable.hourTable.length > 0) {
        this.active = true;
      }
    }
  }

  addHourGroupToDay(): void {
    if (this.disabled) return;



    const newHour: IHourTable = {
      startHour: 0,
      startMinutes: 0,
      endHour: 0,
      endMinutes: 0,
      duration: 0
    };
    if (this.timetable) {
      // cuando ya se tiene el objeto de día
      this.timetable.hourTable = [
        ...this.timetable.hourTable,
        newHour
      ];
      this.changeTimetableField.emit();
    } else {
      // agregar un nuevo objeto ITimetable
      this.addTimetable.emit(this.day);
    }
  }

  changeTime(date: Date, type: 'start' | 'end', index: number): void {
    if (this.disabled) return;
    // const hourTable = cloneDeep(this.timetable.hourTable[index]);
    if (type === 'start') {
      this.timetable.hourTable[index].startHour = date.getHours();
      this.timetable.hourTable[index].startMinutes = date.getMinutes();
    } else if (type === 'end') {
      this.timetable.hourTable[index].endHour = date.getHours();
      this.timetable.hourTable[index].endMinutes = date.getMinutes();
    }
    const start = new Date();
    const end = new Date();
    start.setHours(this.timetable.hourTable[index].startHour);
    start.setMinutes(this.timetable.hourTable[index].startMinutes);
    end.setHours(this.timetable.hourTable[index].endHour);
    end.setMinutes(this.timetable.hourTable[index].endMinutes);
    this.timetable.hourTable[index].duration = differenceInMinutes(end, start);
    // this.timetable = cloneDeep(this.timetable);
    // this.timetable.hourTable[index] = cloneDeep(hourTable);
    this.changeTimetableField.emit(index);
  }

  removeHourGroupToDay(index: number): void {
    if (!this.disabled) {
      this.timetable.hourTable.splice(index, 1);
      this.changeTimetableField.emit(index);
    }
  }

  changeActiveDay(): void {
    if (!this.active) {
      this.timetable?.hourTable?.splice(0);
    } else {
      if (!this.timetable || this.timetable.hourTable.length === 0) {
        this.addHourGroupToDay();
      }
    }
    this.changeTimetableField.emit();
  }
}
